import Loading from './loading.component'

export default Loading
